// apps/client/src/services/activity.ts
import {
  OrganisationActivitiesResponse,
  PlanActivitiesResponse,
  ActivityWithDetails,
} from '@fsp/types';
import { apiClient } from './apiClient';

/**
 * Fetch activities for an organisation
 */
export const fetchOrganisationActivities = async (
  organisationId: string,
  limit: number = 20
): Promise<ActivityWithDetails[]> => {
  const response = await apiClient.get(
    `/organisations/${organisationId}/activities?limit=${limit}`
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch organisation activities: ${response.statusText}`);
  }

  const result: OrganisationActivitiesResponse = await response.json();
  return result?.activities || [];
};

/**
 * Fetch activities for a specific plan
 */
export const fetchPlanActivities = async (
  organisationId: string,
  planId: string,
  limit: number = 20
): Promise<ActivityWithDetails[]> => {
  const response = await apiClient.get(
    `/organisations/${organisationId}/plans/${planId}/activities?limit=${limit}`
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch plan activities: ${response.statusText}`);
  }

  const result: PlanActivitiesResponse = await response.json();
  return result?.activities || [];
};
